import React, { useEffect, useState } from 'react'
import { CommonLayout } from '../commonComponents'
import { Box, Grid, SelectChangeEvent, Typography, useTheme } from '@mui/material'
import ApplicationChart from './component/ApplicationChart'
import OnBoardingLineChart from './component/OnBoardingLineChart'
import OnBoardingStatus from './component/OnBoardingStatus'
import MultipleCart from './component/MultipleCart'
import InvestorLineChat from './component/InvestorLineChat'
import { useDispatch, useSelector } from 'react-redux'
import { RootStateType } from '../../redux-store/reducers'
import { getAumDistributionChart, getCastHistory } from '../../redux-store/actions/userManagement'
import { maskInfo } from '../../utils/utilityFunctions'
import { AumChart, filterType, GetCashHistory } from '../../redux-store/types/api-types'
import useAumTableHook from '../CustomeHook/useAumTableHook'
import { filteringAum } from '../../utils/filtering'
import moment from 'moment'
import OnBoardAccount from './component/OnBoardAccount'

const boxStyle = {
    background: "#FFFFFF",
    borderRadius: '20px',
    boxShadow: '0px 4px 10px 0px #0000000D',
}

const option = {
    chart: {
        type: 'column'
    },
    title: {
        text: '',
    },
    accessibility: {
        announceNewData: {
            enabled: true
        }
    },
    xAxis: {
        type: 'category',
        lineWidth: 0,
    },
    yAxis: {
        title: {
            text: ''
        },
        gridLineWidth: 1, // Increase the gridLineWidth to make the border more visible
        gridLineColor: '#D9E3FF80',

    },
    legend: {
        enabled: false
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },

    series: [
        {
            name: 'Browsers',
            colorByPoint: false,
            color: '#1E90FF',
            // borderRadius: 8,
            pointWidth: 20,
            data: [
                {
                    name: 'Aug 23',
                    y: 63.06,
                },
                {
                    name: 'Sep 23',
                    y: 19.84,
                },
                {
                    name: 'Oct 23',
                    y: 4.18,
                },
                {
                    name: 'Nov 23',
                    y: 4.12,
                },
                {
                    name: 'Dec 23',
                    y: 12.33,
                },
                {
                    name: 'Jan 24',
                    y: 10.45,
                }
            ]
        }
    ],
}

const Index = () => {
    const dispatch = useDispatch();
    const { getAumTable } = useAumTableHook()
    const { typography, palette } = useTheme()

    const { iwappRmId } = useSelector((store: RootStateType) => store.id);

    const [chartOption, setChartOption] = useState(option)
    const [isLoading, setIsLoading] = useState(false)
    const [exportData, setExportData] = useState([])
    const [accountTable, setAccountTable] = useState<any>([]);
    const [cards, setCard] = useState<Array<GetCashHistory>>([]);
    const [aumDistributionError, setAumDistributionError] = useState(false)
    const [castHistoryError, setCastHistoryError] = useState(false)
    const [assetAllocationError, setAssetAllocationError] = useState(false)
    const [aumData, setAumData] = useState<{ aum: { family: any; individual: any }, filterOption: filterType[] }>({} as { aum: { family: any; individual: any }, filterOption: filterType[] });

    useEffect(() => {
        (async function () {
            try {

                if (iwappRmId) {
                    const [res2, res3]: any = await Promise.all([
                        dispatch(getAumDistributionChart({ rmId: iwappRmId })) as unknown | Array<AumChart>,
                        dispatch(getCastHistory({ rmId: iwappRmId })) as unknown | Array<GetCashHistory>
                    ]);

                    if (res2?.isSuccess) {
                        const modifiedRes = {
                            ...res2, result: res2?.result?.map((ele: any) => ({
                                ...ele,
                                customerName: maskInfo(ele?.customerName),
                                // familyName: maskInfo(ele?.familyName)
                            })) ?? []
                        }
                        setExportData(modifiedRes?.result as any);
                        setAccountTable(getAumTable(modifiedRes?.result as Array<AumChart>))

                        // this modification for line chart
                        const modifiedRes2 = {
                            ...res2, result: res2?.result?.map((ele: any) => ({
                                ...ele,
                                customerName: maskInfo(ele?.customerName),
                                familyName: maskInfo(ele?.familyName)
                            }))
                        }
                        setAumData(filteringAum(modifiedRes2?.result as Array<AumChart>) as any);
                    } else {
                        setAumDistributionError(true)
                    }

                    if (res3?.isSuccess) {
                        setCard(res3?.result as Array<GetCashHistory>);
                    } else {
                        setCastHistoryError(true)
                    }


                }
            } catch (e) {
                console.log("error", e)
                setAssetAllocationError(true)
                setAumDistributionError(true)
                setCastHistoryError(true)
            }


        })();
    }, [])

    const momentDates = [...cards].map(obj => moment(obj.navDate, 'YYYYMMDD'));
    const latestIndex = momentDates.reduce((acc, curr, index) => (curr.isAfter(momentDates[acc]) ? index : acc), 0);
    const latestObject = cards[latestIndex];

    const filterHandleChange = (event: SelectChangeEvent) => {
        console.log(event.target.value)
    }

    return (
        <CommonLayout>
            <Grid container columnGap={3} rowGap={3}>
                <Grid container columnGap={3} rowGap={3}>
                    <Grid item lg={5.8} md={12} sm={12} xs={12} sx={boxStyle}>
                        <ApplicationChart />
                    </Grid>
                    <Grid item lg={5.8} md={12} sm={12} xs={12} sx={boxStyle}>
                        <OnBoardingLineChart />
                    </Grid>
                </Grid>
                <Grid container rowGap={3}>
                    <Grid item lg={6} md={12} sm={12} xs={12} >
                        <MultipleCart />
                    </Grid>
                    <Grid item lg={6} md={12} sm={12} xs={12} sx={boxStyle}>
                        <OnBoardingStatus />
                    </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={boxStyle}>
                    <InvestorLineChat
                        options={[
                            { label: '12 Months', value: '1' },
                            { label: '6 Months', value: '2' },
                        ]}
                        isLoading={false}
                        defaultValue={'1'}
                        filterHandleChange={filterHandleChange}
                        chartOption={chartOption}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={boxStyle}>
                    <OnBoardAccount {...{ isLoading, accountTable, aumAmount: latestObject?.netAssets, error: aumDistributionError, exportData, title: 'Investor Details' }} />
                </Grid>

            </Grid>

        </CommonLayout>
    )
}

export default Index